export default {
  data() {
    return {
      loading: false,
      data: [],
      spreadsheetData: [],
      error: null,
      columnHeaders: [],
      studiesData: {},
      mapArray: [],
      mappedValues: [],
      unmappedValues: ["NA"],
      nationalValues: "national",
    };
  },
  methods: {
    fetchData() {
      this.error = this.studies = null;
      this.loading = true;
      const SPREADSHEET_API_URL =
        "https://sheets.googleapis.com/v4/spreadsheets/1bJ5RU_-H3TkzC2i5ymleZAzDCPtYa_F-RW5v-V-sbMI/";
      const SPREADSHEET_API_KEY = "AIzaSyBsww0TiTZDGcFME-VCG8Dv2IIPW0vSDew";
      const gdrivesheet =
        SPREADSHEET_API_URL +
        "values/Sheet1?key=" +
        SPREADSHEET_API_KEY +
        "&prettyPrint=false";

      return fetch(gdrivesheet)
        .then((response) => {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }

          // Examine the text in the response
          return response.json().then((data) => {
            this.data = data;
            this.spreadsheetData = data.values;
            this.columnHeaders = data.values.shift();
            let studiesData = {};
            let mapArray = [];

            // Loop through default data. Loop through map array. If state in default data does not exist in map array, give it a value of 0. If it does exist, give it a new value

            for (let i = 0; i < this.spreadsheetData.length; i++) {
              let stateValues = Array(this.spreadsheetData[i][5]);
              for (let x in stateValues) {
                if (stateValues[x] === undefined || stateValues[x] === "") {
                  stateValues[x] = "NA";
                } else {
                  stateValues[x] = stateValues[x].split(",").map((d) =>
                    d
                      .toLowerCase()
                      .trimStart()
                      .trimEnd()
                  );
                }
              }

              let studyTypeValues = Array(this.spreadsheetData[i][2]);
              for (let x in studyTypeValues) {
                if (
                  studyTypeValues[x] === undefined ||
                  studyTypeValues[x] === " " ||
                  studyTypeValues[x] === ""
                ) {
                  studyTypeValues[x] = ["NA"];
                } else {
                  studyTypeValues[x] = studyTypeValues[x].split(",").map((d) =>
                    d
                      .trimStart()
                      .replace(/\n/gi, "")
                      .trimEnd()
                  );
                }
              }
              let studyTypeCount = Array(this.spreadsheetData[i][2]);
              for (let x in studyTypeCount) {
                if (
                  studyTypeCount[x] === undefined ||
                  studyTypeCount[x] === " " ||
                  studyTypeCount[x] === ""
                ) {
                  studyTypeCount[x] = "NA";
                } else {
                  studyTypeCount[x] = studyTypeCount[x].split(",").map((d) =>
                    d
                      .trimStart()
                      .replace(/\n/gi, "")
                      .trimEnd()
                  );
                }
              }
              this.data.values[i][10] = stateValues;
              this.data.values[i][11] = studyTypeValues;

              for (let j = 0; j < stateValues.length; j++) {
                let state = stateValues[j];
                if (studiesData[state] == null) {
                  studiesData[state] = { total: 0 };
                  mapArray[state] = 0;
                }
                for (let k = 0; k < studyTypeValues.length; k++) {
                  const studyType = studyTypeValues[k];
                  if (studiesData[state] == null) {
                    studiesData[state][studyType] = 1;
                  } else {
                    studiesData[state][studyType] =
                      studiesData[state][studyType] + 1;
                  }
                }
                for (let l = 0; l < studyTypeCount.length; l++) {
                  if (studiesData[state] == null) {
                    studiesData[state]["total"] =
                      studiesData[state]["total"] + 1;
                    mapArray[state] = studiesData[state]["total"];
                  } else {
                    studiesData[state]["total"] =
                      studiesData[state]["total"] + 1;
                    mapArray[state] = studiesData[state]["total"];
                  }
                }
              }
            }

            this.studiesData = studiesData;
            const mapNestedArrays = Object.entries(mapArray).map((x) => x);
            this.mapArray = mapNestedArrays;
            this.mappedValues = mapNestedArrays.filter(
              (eachObj) => eachObj[0] !== "NA" && eachObj[0] !== "national"
            );
          });
        })
        .catch(function(err) {
          console.log("Fetch Error :-S", err);
        });
    },
    filterData(stateAbbr) {
      // If the route.params.state = All, show all data
      if (this.$route.name == "Table" && this.$route.params.state == "INDIA") {
        this.spreadsheetData = this.data.values;
      } else if (
        this.$route.name == "Table" &&
        this.$route.params.state == "unmapped"
      ) {
        let unmappedData = this.data.values.filter((item) => {
          return item[10]
            .map((i) => {
              return this.unmappedValues.includes(i);
            })
            .some((b) => {
              return b;
            });
        });
        this.spreadsheetData = unmappedData;
      } else if (
        this.$route.name == "Table" &&
        this.$route.params.state == "national"
      ) {
        let nationalData = this.data.values.filter((item) => {
          return item[10]
            .map((i) => {
              return this.nationalValues.includes(i);
            })
            .some((b) => {
              return b;
            });
        });
        this.spreadsheetData = nationalData;
      }
      // Else if a cell in the loc_study_state (item[10]) column includes the state name matched by the router, then show only that row
      else {
        let filteredData = this.data.values.filter((item) => {
          return item[10][0].includes(stateAbbr);
        });
        this.spreadsheetData = filteredData;
      }
    },
  },
};
